import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import IntlComponent from 'axway-react-intl';
import { Button, Glyphicon } from 'react-bootstrap';
import { isImageDataURI } from './utils';

class CredentialCardBack extends React.Component {
	constructor(props) {
		super(props);
		IntlComponent.init(this);

		// Credential type (this is here for a reason)
		this.intl.formatMsg('OAuth 2.0 credential', 'credential.oauth2');

		// Tokens action button messages (used below in copyTokens)
		this.intl.formatMsg('Copy access token', 'credential.access');
		this.intl.formatMsg('Copy refresh token', 'credential.refresh');
	}

	/**
	 * Get the internationalized messages by id.
	 */
	getMessage(msgId) {
		const { intl } = this.props;
		return intl.formatMessage({ id: msgId, defaultMessage: ' ' }).trim();
	}

	/**
	 * Get the icon to display for this credential.
	 */
	icon() {
		const { credential } = this.props;
		let icon;
		if (credential.icon) {
			if (isImageDataURI(credential.icon)) {
				icon = (
					<img src={credential.icon} alt="" />
				);
			} else {
				icon = (
					<Glyphicon glyph={` gg ${credential.icon}`} />
				);
			}
		}
		return icon;
	}

	/**
	 * The list of actions that can be performed on the tokens.
	 */
	copyTokens(tokens) {
		return (Object.entries(tokens || [])).map((token) => {
			if (!token[1]) {
				return null;
			}
			const key = token[0] + '_token';
			const spanText = 'credential.' + token[0];
			const element = (
				<div
					className="action"
					key={key}
				>
					<Button
						key={key}
						bsSize="large"
						className="compact"
						onClick={() => this.props.copyTokenToClipboard(token[1])}
					>
						<span>{this.getMessage(spanText)}</span>
					</Button>
				</div>);
			return element;
		});
	}

	render() {
		const { credential, tokensActions, tokens } = this.props;
		const copyTokens = this.copyTokens(tokens);
		return (
			<div className="credential-card back">
				<div className="name" title={credential.name}>{credential.name}</div>
				<div className="icon">{this.icon()}</div>
				<div className="icon2">
					{tokensActions.length ? (
						<Button
							key={tokensActions[0].label}
							className="action-btn"
							bsStyle="link"
							onClick={tokensActions[0].action}
						>
							<Glyphicon glyph="glyphicon glyphicon-remove" />
						</Button>
					) : null}
				</div>
				<div className="actions">
					{copyTokens}
				</div>
				<div className="type">{this.getMessage('credential.oauth2')}</div>
			</div>
		);
	}
}

CredentialCardBack.propTypes = {
	/**
	 * The credentials configured on the service.
	 */
	credential: PropTypes.shape({
		name: PropTypes.string.isRequired,
		icon: PropTypes.string
	}).isRequired,
	/**
	 * The tokens configured on the service.
	 */
	tokens: PropTypes.shape({
		access: PropTypes.string,
		refresh: PropTypes.string
	}),

	/**
	 * The actions available for this card.
	 */
	tokensActions: PropTypes.arrayOf(
		PropTypes.shape({
			label: PropTypes.string.isRequired,
			action: PropTypes.func.isRequired
		})
	)
};

export default injectIntl(CredentialCardBack);
